<template>
   <div class="sd_login_page">
      <div class="form_box">
         <div class="title">
            <h5>注册</h5>
         </div>
         <div class="input_box">
            <h5>欢迎加入ISFAL</h5>
            <el-form :model="form" :rules="rules" ref="ruleForms" class="demo-ruleForm">
               <el-form-item prop="nickName">
                  <el-input v-model="form.nickName" maxlength="11" placeholder="昵称"></el-input>
               </el-form-item>
               <el-form-item prop="email">
                  <el-input v-model="form.email" placeholder="邮箱"></el-input>
               </el-form-item>
               <el-form-item prop="password">
                  <el-input v-model="form.password" placeholder="密码" show-password></el-input>
               </el-form-item>
               <el-form-item prop="password2">
                  <el-input v-model="form.password2" placeholder="确认密码" show-password></el-input>
               </el-form-item>

			   <el-form-item prop="phone">
			      <el-input v-model="form.phone" maxlength="11" placeholder="手机号"></el-input>
			   </el-form-item>
               <el-form-item prop="code">
                  <el-row>
                     <el-col :span="15">
                        <el-input v-model="form.code" placeholder="验证码"></el-input>
                     </el-col>
                     <el-col :span="1">

                     </el-col>
                     <el-col :span="8">
                        <el-button type="primary" class="post_btn" v-if="show" @click="codePost">发送验证码</el-button>
                        <el-button  class="post_btn" v-else>{{count}} s</el-button>
                     </el-col>
                  </el-row>
               </el-form-item>

               <el-form-item>
                 <br>
                  <el-button type="primary" class="login_btn" @click="submitForm()">注册</el-button>
               </el-form-item>
               <el-form-item>
                  <div class="links">
                     <router-link to="/login">我有账号去登录</router-link>
                     <router-link to="/password">忘记密码？</router-link>
                  </div>
               </el-form-item>
               <el-form-item>
                  <el-checkbox class="checke" v-model="checked">已同意并阅读<router-link to="/article/detail/user" target="_blank" style="color:#E41F1F;">《用户协议》</router-link></el-checkbox>
               </el-form-item>
            </el-form>
         </div>
      </div>
   </div>
</template>


<script>
   export default {
      name: 'sd_register_page',
      data() {
         var validatorPhone = function (rule, value, callback) {
            if (value === '') {
               callback(new Error('手机号不能为空'))
            } else if (!/^1\d{10}$/.test(value)) {
               callback(new Error('手机号格式错误'))
            } else {
               callback();
            }
         };
         var validatePass = (rule, value, callback) => {
            if (value === '') {
               callback(new Error('请输入密码'));
            } else {
               if (this.form.password2 !== '') {
                  this.$refs.ruleForms.validateField('password2');
               }
               callback();
            }
         };
         var validatePass2 = (rule, value, callback) => {
            if (value === '') {
               callback(new Error('请再次输入密码'));
            } else if (value !== this.form.password) {
               callback(new Error('两次输入密码不一致!'));
            } else {
               callback();
            }
         };
         return {
            // codeimg: require('../assets/images/imcode.jpg'),
            form: {
               nickName:'',
               "code": "",
               "email": "",
               "password": "",
               "password2":'',
               "phone": ""
            },
            count:60,
            timer: null,
            show: true,
            rules: {
               nickName: [
                  {
                     required: true,
                     message: '请输入昵称',
                     trigger: ['blur']
                  }
               ],
               phone: [
                  { validator: validatorPhone, trigger: 'blur' }
               ],
               password: [
                  { validator: validatePass, trigger: 'blur' }
               ],
               password2: [
                  { validator: validatePass2, trigger: 'blur' }
               ],
               email: [
                  {
                     required: true,
                     type: 'email',
                     message: '请输入正确的邮箱地址',
                     trigger: ['blur', 'change']
                  }
               ],
               code: [{
                  required: true,
                  message: '请输入验证码',
                  trigger: 'blur'
               }, ],
            },
            checked:false,
         };
      },
      created() {

      },
      activated() {
         //只刷新数据，不改变整体的缓存

      },
      methods: {
         submitForm() {
            this.$refs['ruleForms'].validate((valid) => {
               if (valid) {
                  if(this.checked){
                     this.register();
                  } else{
                     this.$message.error('请阅读并同意用户协议');
                  }
               } else {
                  console.log('error submit!!');
                  return false;
               }
            });
         },
         register() {
            var _this = this;
            _this.$api.register({
               ...this.form
            }).then(res => {
               if (res.code == 200) {
                  _this.$router.replace('/login');
               } else {
                  _this.$message.error(res.msg);
               }
            }).catch(function(error) {
               _this.$message.error(error.msg);
            });
         },
         setTime(){
            const TIME_COUNT = 60;
            if (!this.timer) {
               this.count = TIME_COUNT;
               this.show = false;
               this.timer = setInterval(() => {
                  if (this.count > 0 && this.count <= TIME_COUNT) {
                     this.count--;
                  } else {
                     this.show = true;
                     clearInterval(this.timer);
                     this.timer = null;
                  }
               }, 1000)
            }
         },
         //发送验证码
         codePost(){
            var _this = this;
            if (/^1\d{10}$/.test(this.form.phne)) {
               _this.$message.error('手机号格式错误');
               return false;
            }
            _this.$api.sendCode({
               phone:this.form.phone
            }).then(res => {
               if (res.code == 200) {
                  this.$message({
                     message: '发送成功！',
                     type: 'success'
                  });
                  this.setTime();
               } else {
                  _this.$message.error(res.msg);
               }
            }).catch(function(error) {
               _this.$message.error(error.msg);
            });
         }
      }
   }
</script>
<style lang="less">

</style>
